
    module.exports = {
      render: function(){with(this){return _c('div',{staticClass:"overview"},[_c('div',{staticClass:"overviewContainer"},[_c('router-view')],1)])}},
      staticRenderFns: []
    };
  


//////////////////
// WEBPACK FOOTER
// ./src/view/overview.html
// module id = 192
// module chunks = 0